import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

interface ApproveBatchEnrollmentInvitationParams {
  invitationId: string;
}

export const approveBatchEnrollmentInvitation = createApiThunk<void, ApproveBatchEnrollmentInvitationParams>(
  "admin/batchEnrollmentInvitation/approve",
  async ({ invitationId }, { extra: { adminRepository } }) => {
    await adminRepository!.approveBatchEnrollmentInvitation(invitationId);
  },
);

export const resetApproveBatchEnrollmentInvitation = createAction("admin/batchEnrollmentInvitation/resetApprove");
